import React  from "react";
import $ from "jquery";
import { AxiosResponse } from "axios";

import Loading from '../../../../intelws_portal/constructs/elements/Loading';
import { IPageComponentProps } from "../../../../declarations/common";
import { get, getCancelToken, post } from "../../../../intelws_portal/utils/backendInterface";
import { IMenuOptionsConfig } from "../../../App";
import Messages, { IMessageRepr } from "./Dashboard/Messages";
import clientIcon from '../../../../external/backPages/img/images/svg icons/client_dashboard_svg_icons/CPASAGE_Client home page icons-13.svg';
import teamIcon from '../../../../external/backPages/img/images/svg icons/client_dashboard_svg_icons/CPASAGE_Client home page icons-14.svg';
import ContentBoxTable from "../../../../intelws_portal/bundles/ContentBoxTable";
import { IDataRepr } from "../../../../intelws_portal/constructs/elements/Table";
import ModalForm from "../../modal/ModalForm";

interface IMatchProps {
    userId: string
}

interface IFetchForms extends AxiosResponse {
    data: {
        data: IDataRepr[]
    }
}

export interface IClientCommunicationProps<T> extends IPageComponentProps<T> {
    mutator: {
        currentPage?: (currentPage: string) => void,
        getMenuOptionsConfig: () => IMenuOptionsConfig
    }
}

function ClientForm(props: IClientCommunicationProps<IMatchProps>) {
    const ENDPOINT = "api/clientdashboard/";
    const [isLoaded, setIsLoaded] = React.useState(false);

    const [formTableData, setFormTableData] = React.useState<IDataRepr[]>([]);

    const [modalFormId, setModalFormId] = React.useState(-1);

    const cancelTokenSource = React.useRef(getCancelToken());

    React.useEffect(() => {
        props.mutator.currentPage?.("ClientForms");
        const queryParams = {
            section: "get_forms"
        }

        const requestResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchForms>

        requestResponse.then((response) => {
            setFormTableData(response.data.data);
            setIsLoaded(true);
        })
    }, [])

    const inputCallback = (index: number, accessKey: string, value?: boolean | string | HTMLCollectionOf<HTMLOptionElement>) => {
        console.log(index);
        console.log(accessKey);
        console.log(value);
        if (value == "fillOutForm") {
            setModalFormId(formTableData[index].id);
            $("#formSubmissionModal").modal("show")
        }
    }

    const getContent = () => {
        const title = "Form Organizers";
        const hasSearch = true;
        const hasRecords = true;
        const columnNames = ["Form Name", "Created Date", "Actions"];
        const accessKeys = ["fo_name", "fo_created_date", "actions"];
        return (
            <ContentBoxTable title={title} columnNames={columnNames} accessKeys={accessKeys}
                hasSearch={hasSearch} hasRecords={hasRecords} tableData={formTableData} inputCallback={inputCallback}
             />
        )
    }

    if (!isLoaded) {
        return <Loading />
    } else {
        return (
                <div>
                    {getContent()}
                    <ModalForm formId={modalFormId} closeModal={() => setModalFormId(-1)} />
                </div>
        )
    }
}

export default ClientForm;